import {createContext, useContext} from 'react';
import {useForm, UseFormReturn} from 'react-hook-form';
import {WorkStagesServiceData} from '../../../../../../shared/types/form.types';

interface FormContextProps {
  form: UseFormReturn<WorkStagesServiceData>;
}

export const StepsFormContext = createContext<FormContextProps | null>(null);

export const useStepsFormContext = () => {
  const context = useContext(StepsFormContext);
  if (!context) {
    throw new Error('useFormContext must be used within a FormProvider');
  }

  return context.form;
};

export const useStepsForm = (defaultValues?: WorkStagesServiceData) => {
  const form = useForm<WorkStagesServiceData>({
    defaultValues,
  });

  return form;
};
